import { lsPost, safeAwait } from 'utils/request'

export const logout = () => {
  return safeAwait(lsPost('/users/logout'))
}
